<template>
  <div>
    <div class="menu-title">
      <h1 class="menu-title-main">MENU</h1>
      <p class="menu-title-sub">料金プラン</p>
    </div>
    <HIFU/>
    <Subsc/>
    
  </div>
</template>

<script>
import Subsc from './TabMenuSubscription.vue'
import HIFU from './TabMenuHIFU.vue'
export default {
  name: 'app',
  components: {
    Subsc,
    HIFU
  }
}
</script>

<style>
  @import "../../css/style.css";

  .mg-t-150{
    margin-top: 150px;
  }

  .mg-b-150{
    margin-bottom: 150px;
  }

    /* PC表示 */
  @media screen and (min-width:821px){
    .menu-title{
      text-align: center;
      color: var(--main-color);
      margin:50px auto 0 auto;
    }

    .menu-title-main{
      font-size: 2.5rem;
      letter-spacing: 0.2em;
    }

    .menu-title-sub{
      font-size: 1rem;
      margin-top: 0.5em;
      
    }
    .menu_text{
      margin: 10px 0px;
  }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    /* div{
      width:100%;
      margin:auto;
    } */

    .menu-title{
      text-align: center;
      color: var(--main-color);
      margin:2em auto 0 auto;
    }

    .menu-title-main{
      font-size: 5vw;
      letter-spacing: 0.2em;
      margin-bottom: 0.5em;
    }

    .menu-title-sub{
      font-size: 2vw;
      margin-top: 1em;
      
    }
    .menu_text{
      font-size:2vw;
      margin: 10px 0px;
    }
  }
</style>